export default "__VITE_ASSET__yFnNBCWY__"